import hospitalInfections from './hospital-infections/index.json';
import handBorneMicroorganisms from './hand-borne-microorganisms/index.json';

const microbiology = {
    hospitalInfections,
    handBorneMicroorganisms,
};

export default microbiology;
